module.exports = __webpack_public_path__ + "media/images/athletes/2810-8a30611a5d1b39e2e4cec210bedccce6.png";